import React, { useState, useEffect } from 'react';
import { TableColumn } from 'react-data-table-component';
import { Circle, Modal, CheckBox } from '@wajeez-web/components/ui';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { useCommonSelector } from '@wajeez-web/stores/common';

interface ManageTableColumnsProps {
  selectedColumns: TableColumn<any>[];
  defaultColumns: any[];
  setSelectedColumns: (clo: any[]) => void;
  allCols: TableColumn<any>[];
  open: boolean;
  setOpen: (open: boolean) => void;
}

const ManageTableColumns = ({
  selectedColumns,
  defaultColumns,
  open,
  setOpen,
  setSelectedColumns,
  allCols,
}: ManageTableColumnsProps) => {
  const [columns, setColumns] = useState(defaultColumns);
  const [newSelectedColumns, setNewSelectedColumns] = useState(selectedColumns);
  const { lang } = useCommonSelector((store) => store.common.settings);

  const onSelect = (i: number) => {
    const col = [...columns];
    col[i] = { ...col[i], isSelected: !col[i].isSelected };
    setColumns(col);
  };

  useEffect(() => {
    const col: TableColumn<any>[] = [];
    allCols.forEach((item) => {
      columns.forEach((ele) => {
        if (item.name === ele.name && ele.isSelected) {
          col.push(item);
        }
      });
    });

    setNewSelectedColumns(col);
  }, [columns, allCols]);

  useEffect(() => {
    const col = columns.map((item) => {
      let isSelected = false;
      selectedColumns.forEach((ele) => {
        if (ele.name === item.name) {
          isSelected = true;
        }
      });

      return { ...item, isSelected };
    });
    setColumns(col);
  }, [allCols, selectedColumns]);
  return (
    <Modal
      open={open}
      withScroll={true}
      onClose={() => setOpen(false)}
      onSubmit={() => setSelectedColumns(newSelectedColumns)}
      title="Manage Columns"
    >
      <div className="w-full h-full flex justify-between">
        <div className="w-full">
          <div
            className={`text-sm text-textPrimary mb-6 ${
              lang === 'ar' ? 'text-right' : 'text-left'
            }`}
          >
            {lang === 'en'
              ? 'Select which columns are visible for you. To change the column order, drag and drop the visible fields.'
              : 'اختر الأعمدة التي ستكون مرئية لك. لتغيير ترتيب الأعمدة, اسحب وضع الحقول المرئية.'}
          </div>
          <div className="flex flex-row space-s-2 w-full">
            <div className="border h-full overflow-y-auto flex flex-col border-gray-100 rounded-lg w-full">
              <div className="p-4 w-full border-b border-gray-50 flex flex-row align-middle  space-s-1">
                <div>
                  <ReturnTranslatedText
                    text={`ModalTitles.${'Available Columns'}`}
                  />
                </div>
                <Circle
                  value={columns.length + ''}
                  bg={'gray-200 '}
                  color="gray-500"
                />
              </div>
              <div className="p-4  h-96 flex flex-col space-y-1">
                {columns.map((item, i) => {
                  return (
                    item.id !== 1 && (
                      <div
                        key={item.header + i}
                        className="flex text-base flex-row -space-s-2"
                      >
                        <CheckBox
                          name="selected_col"
                          label={item.header}
                          checked={item.isSelected}
                          onClick={() => onSelect(i)}
                        />
                      </div>
                    )
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ManageTableColumns;
